import { render, staticRenderFns } from "./AppCookiePolicyCategory.vue?vue&type=template&id=5cacd86e&scoped=true&"
import script from "./AppCookiePolicyCategory.vue?vue&type=script&lang=js&"
export * from "./AppCookiePolicyCategory.vue?vue&type=script&lang=js&"
import style0 from "./AppCookiePolicyCategory.vue?vue&type=style&index=0&id=5cacd86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cacd86e",
  null
  
)

export default component.exports